import { api } from '@weareconceptstudio/core';

export const universalApi = {
	get: async (options: any) => {
		let token: string | null = null;
		if (typeof window === 'undefined') {
			try {
				const { cookies, headers } = require('next/headers');
				token = cookies().get('accessToken')?.value || headers().get('accessToken');
			} catch {}
		}
		return api.get({ ...options, userToken: token });
	},
};
